import { useStepper } from '@common/context/StepperContext'
import { Stack } from '@mui/material'
import { Suspense, useEffect } from 'react'
import SelectExams from './SelectExams'
import SubjectsTimepointsTable from '../timepoint/SubjectsTimepointsTable'
import UpdateSubmissionStatus from './UpdateSubmissionStatusView'
import { ContainerParam } from '@features/subject/subject.types'

export default function ReassignExam({
  containers,
  assignableTimepointSubmissions,
  currentTimepointSubmissionId,
}: {
  containers?: ContainerParam[]
  assignableTimepointSubmissions: string[]
  currentTimepointSubmissionId?: string
}) {
  const { activeStep, setActiveStep } = useStepper()

  useEffect(() => {
    setActiveStep(0)
    return () => {
      setActiveStep(0)
    }
  }, [setActiveStep])

  const stepComponents = [
    () => <SelectExams containers={containers} />,
    () => <SubjectsTimepointsTable assignableTimepointSubmissions={assignableTimepointSubmissions} />,
    () => <UpdateSubmissionStatus isExpandable={true} currentTimepointSubmissionId={currentTimepointSubmissionId} />,
    () => <UpdateSubmissionStatus isExpandable={false} currentTimepointSubmissionId={currentTimepointSubmissionId} />,
  ]

  // Use the activeStep to determine which component to render
  const StepComponent = stepComponents[activeStep]

  return (
    <Stack padding={2} width={'100%'} height={'100%'} overflow={'auto'} alignItems="center">
      <Suspense fallback={<div>Loading...</div>}>{StepComponent ? <StepComponent /> : null}</Suspense>
    </Stack>
  )
}
